import { useEffect, useState } from 'react';
// Breakpoint values match those defined in theme.css
const breakpoints = {
    xs: '36rem',
    sm: '48rem',
    md: '62rem',
    lg: '75rem',
    xl: '90rem',
};
const resolveQuery = (input) => 'min' in input
    ? `(min-width: ${breakpoints[input.min]})`
    : `(max-width: calc(${breakpoints[input.max]} - 1px))`;
/**
 * This hook is currently only in use in the legacy header's mobile menu
 * if it needs to be used in other places, it should be moved to a more generic location.
 */
export const useMediaQuery = (input) => {
    const query = resolveQuery(input);
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
    useEffect(() => {
        let mounted = true;
        const mql = window.matchMedia(query);
        const handler = (e) => {
            if (mounted) {
                setMatches(e.matches);
            }
        };
        mql.addEventListener('change', handler);
        return () => {
            mounted = false;
            mql.removeEventListener('change', handler);
        };
    }, [query]);
    return matches;
};
